import { ImageGroupeByContributorModel } from './image.groupe.by.contributor.model';

export class PagedImageGroupeByContributorDetails {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: ImageGroupeByContributorModel[] = [];
}
